import { api } from '../../../renderer/services/http';

export const poService = {
  getAll: async () => api<any[]>('/api/purchase/orders'),
  getById: async (id: string) => api(`/api/purchase/orders/${id}`),
  create: async (body: any) => api('/api/purchase/orders', { method: 'POST', body: JSON.stringify(body) }),
  update: async (id: string, body: any) => api(`/api/purchase/orders/${id}`, { method: 'PUT', body: JSON.stringify(body) }),
  submit: async (id: string) => api(`/api/purchase/orders/${id}/submit`, { method: 'POST' }),
  approve: async (id: string) => api(`/api/purchase/orders/${id}/approve`, { method: 'POST' }),
  reject: async (id: string, reason: string) =>
    api(`/api/purchase/orders/${id}/reject`, { method: 'POST', body: JSON.stringify({ reason }) }),
};
